import bootstrap from "./bootstrap";
import "regenerator-runtime/runtime";

import "./App.scss";

const query = new URLSearchParams(window.location.search);
const param = query.get('source');

if (param === "pivot") {
    sessionStorage.setItem("source", param);
} else if (sessionStorage.getItem("source") !== "pivot") {
    sessionStorage.setItem("source", "fsao");
}
bootstrap(()=>{});
